import React from "react";

const PageHeader = ({ title, selectedBrand, children, subtitle }) => {
  return (
    <div className="mb-4 sm:mb-6">
      <h1 className="mb-1 text-2xl font-semibold break-words text-white sm:text-3xl">
        {title} {selectedBrand?.name ? `- ${selectedBrand.name}` : ""}
      </h1>
      {subtitle && (
        <p className="mb-1 text-sm text-gray-400 sm:text-base">{subtitle}</p>
      )}
      {children}
    </div>
  );
};

export default PageHeader;
